// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2wY8H","fileDisabled":"File_fileDisabled__3Nqmh"};